





































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DatePickerOptions } from "element-ui/types/date-picker";
import QuaterSelectorVue from "./QuaterSelector.vue";
import { CloseObject } from "@/views/Closing.vue";

@Component({
    components: {
        "quater-select": QuaterSelectorVue,
    }
})
export default class MonthSelector extends Vue {
    //用于判断是否为范围月份选择器，默认false
    @Prop({ type: Boolean, default: false })
    isRange?: Boolean;
    //用于判断是否为报税界面，默认false
    @Prop({ type: Boolean, default: false })
    isTax?: Boolean;
    //用于判断是否为极度选择器
    @Prop({ type: Boolean, default: false })
    isQuater?: Boolean;
    // 用户判断是否有特殊的获取日期的api接口
    @Prop({ type: String })
    api?: string;

    @Prop({ type: Array })
    appointDate?: Date[];

    @Prop({ type: Boolean, default: false })
    oneMonthMore?: boolean;

    // 判断是否为结账调用
    @Prop({ type: Boolean, default: false })
    isClose!: Boolean;

    @Prop({ type: Object })
    closePeriods!: CloseObject | null;

    // 月份列表数据
    periods: MonthSelector.Period[] = [];
    // 开始时间，用于禁用
    startTime: number = 0;
    // 截至时间，用于禁用
    endTime: number = 0;

    // 为日记账用，接受endmonth变量
    dayAccountEndMonth: string = "";
    isSb: boolean = false;

    mounted() {
        this.getPeriods();
    }

    getPeriods(isSb?:boolean) {
        return new Promise((resolve, reject) => {
            if (!this.isClose) {
                let url: string;
                if (this.api) url = this.api;
                // 如果有特殊的api接口,则调此接口地址
                else url = `periods/${this.$store.state.accountBook.id}/findperiods`;
                Vue.axios({
                    url: url,
                    method: "POST"
                }).then(res => {
                    this.periods = res.data.periods;
                    if(this.isTax) {
                        this.startTime = new Date(2020,0,1).getTime()
                        for(let i = 0;i<this.periods.length;i++){
                            if(+(this.periods[i].year) < 2020) this.periods[i].visable =0
                        }
                    }
                    else this.startTime = res.data.startTime;
                    let date = this.$utils.strToDate(
                        this.periods[this.periods.length - 1].period
                    );
                    if(this.isSb){
                      this.endTime = res.data.endTime;
                      let time = this.$utils.dateAdd(new Date(), "m", -1)
                      this.endTime = time.getTime()
                      if(this.$utils.simpleDateFormat(new Date(res.data.endTime),"m") === this.$utils.simpleDateFormat(new Date(time.getTime()),"m")){
                        date = this.$utils.strToDate(
                        this.periods[this.periods.length - 1].period
                        );
                      }else {
                        date = this.$utils.strToDate(
                        this.periods[this.periods.length - 2].period
                        );
                      }
                    }
                    else this.endTime = res.data.endTime;

                    this.dayAccountEndMonth = res.data.endPeriod;
                    let endMonth = res.data.endPeriod.substring(0, 4) + "-" + res.data.endPeriod.substring(4, 6);

                    if (this.isRange) {
                        if (this.appointDate) {
                            this.rangeVal = this.appointDate;
                        } else {
                            this.rangeVal = [date, date];
                        }
                        this.$emit("change", this.rangeString);
                        resolve(this.rangeString);
                    } else if (this.isQuater) {
                        this.firstVal = date;
                        // this.quaterMin = this.firstVal.getFu
                        this.quaterChange(this.quaterMin, this.quaterMax);
                    } else {
                        this.dateVal = date;
                        this.$emit("change", this.dateString, this.dayAccountEndMonth);
                        resolve(this.dateString);
                    }
                    if (res.data.endPeriod) this.$store.dispatch("changeCurrentPeriod", res.data.endPeriod);
                    if (res.data.startPeriod) this.$store.dispatch("changeStartPeriod", res.data.startPeriod);
                });
            }
            resolve("");
        })        
    }

    get pickerOptions(): DatePickerOptions {
        return {
            disabledDate: time => {
                let start: number = <number>this.startTime;
                let end: number = <number>this.endTime;
                if (this.oneMonthMore) end = this.$utils.dateAdd(new Date(end), "m", 1).getTime();
                return time.getTime() < start || time.getTime() > end;
            }
        };
    }

    @Watch("closePeriods")
    closePeriodChange(val: CloseObject) {
        this.periods = val.periods;
        this.startTime = val.startTime;
        this.endTime = val.endTime;
        if (this.periods.length > 0) {
            this.dateVal = this.$utils.strToDate(
                this.periods[this.periods.length - 1].period
            );
            this.$emit("change", this.dateString);
        }
    }

    // 让月份按钮与月份选择器同步active
    syncActive(month: MonthSelector.Period) {
        if (this.isQuater) {
            if (
                +month.period >= +this.quaterMin &&
                +month.period <= +this.quaterMax
            )
                return true;
            else return false
        }
        if (this.isRange) {
            if (
                +month.period >= +this.rangeString[0] &&
                +month.period <= +this.rangeString[1]
            )
                return true;
        } else {
            if (+month.period === +this.dateString) return true;
        }
        return false;
    }

    // 之前按钮是否为disable
    get beforeActive() {
        if (this.periods.length > 0) {
            let min = this.periods[0].period;
            if (this.isQuater) {
                if (+this.quaterMin < +min) return true;
            }
            if (this.isRange) {
                if (+this.rangeString[0] < +min) return true;
            } else {
                if (+this.dateString < +min) return true;
            }
        }
        return false;
    }
    oneSb(){
        return this.$utils.simpleDateFormat(new Date(this.endTime),"m")
    }
    async getSb(isChange:boolean){
        this.isSb = isChange;
        await this.getPeriods(isChange)
        
    }

    // 单月选择
    dateVal: Date = new Date();
    get dateString() {
        return this.$utils.simpleDateFormat(this.dateVal, "m");
    }
    dateChange() {
        this.syncBar();
        this.$emit("change", this.dateString, this.dayAccountEndMonth);
    }

    // 范围月份选择
    rangeVal: Date[] = [];
    get rangeString() {
        let date: string[] = [];
        this.rangeVal.forEach(v => {
            date.push(this.$utils.simpleDateFormat(v, "m"));
        });
        return date;
    }
    rangeChange() {
        this.syncBar();
        this.$emit("change", this.rangeString);
    }

    // 季度月份选择范围
    firstVal: Date = new Date();

    get quaterMin() {
        let year: string = this.firstVal.getFullYear().toString();
        let month: string = (this.firstVal.getMonth() + 1).toString();
        let monthNum = Number(month)
        let quater = Math.ceil(monthNum / 3);
        let minMonth = ""
        if (quater === 1) minMonth = "01"
        else if (quater === 2) minMonth = "04"
        else if (quater === 3) minMonth = "07"
        else if (quater === 4) minMonth = "10"
        return year + minMonth
    }
    get quaterMax() {
        let year: string = this.firstVal.getFullYear().toString();
        let month: string = (this.firstVal.getMonth() + 1).toString();
        let monthNum = Number(month)
        let quater = Math.ceil(monthNum / 3);
        let maxMonth = ""
        if (quater === 1) maxMonth = "03"
        else if (quater === 2) maxMonth = "06"
        else if (quater === 3) maxMonth = "09"
        else if (quater === 4) maxMonth = "12"
        return year + maxMonth
    }
    quaterChange(min: string, max: string) {
        this.firstVal = new Date(`${max.substr(0, 4)}-${max.substr(4)}`);
        this.syncBar();
        this.$emit("change", this.quaterMin,this.quaterMax);
    }

    // 点击月份按钮
    clickMonth(period: MonthSelector.Period) {
        let date = this.$utils.strToDate(period.period);
        // 季度选择
        if (this.isQuater) {
            if (period.month === "1月" || period.month === "2月" || period.month === "3月") {
                this.firstVal = new Date(period.year + "-" + "03");
            }
            else if (period.month === "4月" || period.month === "5月" || period.month === "6月") {
                this.firstVal = new Date(period.year + "-" + "06");
            }
            else if (period.month === "7月" || period.month === "8月" || period.month === "9月") {
                this.firstVal = new Date(period.year + "-" + "09");
            }
            else if (period.month === "10月" || period.month === "11月" || period.month === "12月") {
                this.firstVal = new Date(period.year + "-" + "12");
            }

            this.firstVal = new Date(`${this.quaterMax.substr(0, 4)}-${this.quaterMax.substr(4)}`);
            this.$emit("change", this.quaterMin,this.quaterMax);
        } else if (this.isRange) {
            this.rangeVal = [date, date];
            this.$emit("change", this.rangeString);
        } else {
            this.dateVal = date;
            this.$emit("change", this.dateString, this.dayAccountEndMonth);
        }
    }

    // 点击之前
    clickBefore() {
        this.periods.forEach(e => {
            e.year = (+e.year - 1).toString();
            e.period = (+e.period.substring(0, 4) - 1) + e.period.substring(4);
            if (+e.period <= +this.$store.state.accountBook.closePeriod && +e.period >= +this.$store.state.accountBook.startPeriod) e.isaccounted = 1;
            else e.isaccounted = 0; 
        });
    }

    // 判断之前按钮是否可点
    get beforeDisabled() {
        if (this.periods[0]) return +this.periods[0].period <= +this.$store.state.accountBook.startPeriod;
        return true;
    }

    // 点击之后
    clickAfter() {
        this.periods.forEach(e => {
            e.year = (+e.year + 1).toString();
            e.period = (+e.period.substring(0, 4) + 1) + e.period.substring(4);
            if (+e.period <= +this.$store.state.accountBook.closePeriod && +e.period >= +this.$store.state.accountBook.startPeriod) e.isaccounted = 1;
            else e.isaccounted = 0;
        });
    }

    // 判断之后按钮是否可点
    get afterDisabled() {
        const end = this.oneMonthMore ? this.oneMoreFn() : +this.$store.state.accountBook.currentPeriod;
        if (this.periods[this.periods.length - 1]) return +this.periods[this.periods.length - 1].period >= end;
        return true;
    }

    // 之后按钮是否为disable
    get afterActive() {
        if (this.periods.length > 0) {
            let max = this.periods[this.periods.length - 1].period;
            if (this.isQuater) {
                return +this.quaterMax > +max;
            }
            if (this.isRange) {
                if (+this.rangeString[1] > +max) return true;
            } else {
                if (+this.dateString > +max) return true;
            }
        }
        return false;
    }

    addZero(n: number) {
        if (n < 10) return `0${n}`;
        else return n.toString();
    }

    // 同步修改左侧显示
    syncBar() {
        if (this.periods.length > 0) {
            let year = this.periods[this.periods.length - 1].year;
            if (this.isQuater) {
                year = this.quaterMin.substring(0, 4);
            } else if (this.isRange) {
                year = this.rangeVal[0].getFullYear().toString();
            } else {
                year = this.dateVal.getFullYear().toString();
            }
            this.periods.forEach((e, i) => {
                e.year = year;
                e.period = `${year}${this.addZero(i + 1)}`;
                if (+e.period <= +this.$store.state.accountBook.closePeriod && +e.period >= +this.$store.state.accountBook.startPeriod) e.isaccounted = 1;
                else e.isaccounted = 0;
                if (+e.period < +this.$store.state.accountBook.startPeriod || +e.period > +this.$store.state.accountBook.currentPeriod) e.visable = 0;
                else e.visable = 1;
                e.month = `${i + 1}月`;
            });
            // this.$forceUpdate();
        }
        return false;
    }

    oneMoreFn() {
        const current: string = this.$store.state.accountBook.currentPeriod;
        const end = this.$utils.simpleDateFormat(this.$utils.dateAdd(new Date(`${current.substring(0, 4)}-${current.substring(4)}`), "m", 1), "m");
        return +end;
    }
}
